export default {
  rowSelection: false,
  fieldControl: true,
  columns: [
    {
      title: '账号',
      dataIndex: 'vendorCode',
      width: 100,
      fixed: 'left',
      render: 'vendorCodeRender'
    },
    {
      title: '类型',
      dataIndex: 'typeName',
      width: 100,
    },
    {
      title: '承包商名称',
      dataIndex: 'name',
      width: 250,
    },
    {
      title: '认证状态',
      dataIndex: 'statusName',
      width: 120,
    },
    {
      title: '法人姓名',
      dataIndex: 'corporateName',
      width: 120,
    },
    {
      title: '法人电话',
      dataIndex: 'phoneHide',
      width: 140,
    },
    {
      title: '负责人姓名',
      dataIndex: 'managerName',
      width: 120,
    },
    {
      title: '负责人电话',
      dataIndex: 'managerPhone',
      width: 140,
    },
    {
      title: '地址',
      dataIndex: 'address',
      width: 300,
      ellipsis: {
        overlayStyle: {
          maxHeight: 360,
        },
      },
    },
    {
      title: '门店',
      dataIndex: 'companyNames',
      width: 240,
      ellipsis: true,
    },
    {
      title: '操作',
      dataIndex: 'actionTool',
      width: 170,
      render: 'actionTool',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'vendorCodeOrName',
      label: '名称/账号',
      itemType: 'input',
      placeholder: '请输入名称/账号',
    },
  ],
  footer: [
    {
      label: '新增',
      type: 'primary',
      auth: 'workerManagementAdd',
      events: ['onClick:onAdd'],
    },
  ],
};
